import SelfCustodyViaWeb3Auth from './SelfCustodyViaWeb3Auth.js';
import { jsx } from 'react/jsx-runtime';

function Footer() {
  return /*#__PURE__*/jsx("div", {
    className: "w3a-modal__footer",
    children: /*#__PURE__*/jsx("div", {
      className: "w3a-footer",
      children: /*#__PURE__*/jsx("div", {
        children: /*#__PURE__*/jsx("div", {
          children: /*#__PURE__*/jsx(SelfCustodyViaWeb3Auth, {})
        })
      })
    })
  });
}

export { Footer as default };
